import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  
  Users,
  BookOpen,
  Bot,
  ClipboardList,
  Calendar,
  Settings,
  PieChart,
} from "lucide-react";
import logo from "../images/Logo For Website 01.png";

// Updated navigation items for demo
const DEMO_NAVIGATION = [
//   { 
//     icon: <PieChart size={20} />, 
//     label: "Dashboard", 
//     path: "/demo",
//     comingSoon: true 
//   },
  { 
    icon: <Bot size={20} />, 
    label: "AI Assistant", 
    path: "/demo/ai-assistant",
    comingSoon: false 
  },
  { 
    icon: <Users size={20} />, 
    label: "Students", 
    path: "/demo/students",
    comingSoon: false 
  },
  { 
    icon: <Calendar size={20} />, 
    label: "Schedule", 
    path: "/demo/schedule",
    comingSoon: false 
  },
//   { 
//     icon: <BookOpen size={20} />, 
//     label: "Lessons", 
//     path: "/demo/lessons",
//     comingSoon: true 
//   },
//   { 
//     icon: <ClipboardList size={20} />, 
//     label: "Assignments", 
//     path: "/demo/assignments",
//     comingSoon: true 
//   },
//   { 
//     icon: <Settings size={20} />, 
//     label: "Settings", 
//     path: "/demo/settings",
//     comingSoon: true 
//   }
];

const DemoSidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Group navigation items
  const mainNavItems = DEMO_NAVIGATION.slice(0, 3); // Dashboard, AI Assistant, Students
  const secondaryNavItems = DEMO_NAVIGATION.slice(3); // Rest of the items

  return (
    <div className="w-[280px] h-screen border-r border-gray-200 flex flex-col py-5 px-3">
      <div className="px-3 mb-8 flex items-center justify-between">
        <img src={logo} alt="Moinduel Logo" className="h-8" />
        <button 
          onClick={() => navigate('/')}
          className="text-xs text-gray-500 hover:text-gray-700 px-2 py-1 rounded-md hover:bg-gray-100"
        >
          Exit Demo
        </button>
      </div>

      {/* Main Navigation */}
      <div className="px-3 mb-2">
        <h2 className="text-xs font-semibold text-gray-400 uppercase">Main</h2>
      </div>
      <nav className="space-y-1 mb-6">
        {mainNavItems.map((item, index) => (
          <SidebarItem
            key={index}
            icon={item.icon}
            label={item.label}
            active={location.pathname === item.path}
            comingSoon={item.comingSoon}
            onClick={() => !item.comingSoon && navigate(item.path)}
          />
        ))}
      </nav>

      {/* Secondary Navigation */}
      {/* <div className="px-3 mb-2">
        <h2 className="text-xs font-semibold text-gray-400 uppercase">Features</h2>
      </div> */}
      <nav className="space-y-1">
        {secondaryNavItems.map((item, index) => (
          <SidebarItem
            key={index}
            icon={item.icon}
            label={item.label}
            active={location.pathname === item.path}
            comingSoon={item.comingSoon}
            onClick={() => !item.comingSoon && navigate(item.path)}
          />
        ))}
      </nav>

      {/* Demo Badge */}
      <div className="mt-auto px-3 py-4">
        <div className="bg-gray-50 rounded-lg p-3">
          <div className="text-xs font-medium text-gray-900">Demo Version</div>
          <div className="text-xs text-gray-500">Exploring AI Assistant & Students features</div>
        </div>
      </div>
    </div>
  );
};

const SidebarItem = ({ icon, label, active, comingSoon, onClick }) => (
  <div
    onClick={onClick}
    className={`flex items-center justify-between px-3 py-2 rounded-lg cursor-pointer text-sm font-medium
      ${
        active
          ? "text-gray-900 bg-gray-100"
          : comingSoon
          ? "text-gray-400 cursor-not-allowed"
          : "text-gray-700 hover:bg-gray-100 hover:text-gray-900"
      }`}
  >
    <div className="flex items-center space-x-3">
      <div
        className={`${
          active
            ? "text-gray-900"
            : comingSoon
            ? "text-gray-400"
            : "text-gray-700"
        }`}
      >
        {icon}
      </div>
      <span>{label}</span>
    </div>
    {comingSoon && (
      <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-gray-100 text-gray-600">
        Soon
      </span>
    )}
  </div>
);

export default DemoSidebar;